import { useContext } from 'react'
import MyProfileContext from '@/components/Context/MyProfileContext'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Périmètre Care COMPLET (écrans propres à l'officine : Mon Comptoir, Activité de
 * l'équipe, paramétrage LGO / base produit / dossiers surveillés). Accordé uniquement aux
 * pharmacies — absent pour un professionnel de santé hors officine (kiné, bilan de
 * prévention seul). Cf. `ROLE_DYNAMIC_ROUTE_CARE_FULL_SCOPE` (User::getRoles côté
 * @group-api) et `docs/CARE_PROFESSIONS.md` : « Le front s'en sert pour masquer LGO,
 * comptoir, équipe, base produit ».
 *
 * Version plain function (pas un hook) : utilisable depuis les `fnDisplay` de routes, qui
 * reçoivent `dataMyProfile` en argument hors contexte React.
 */
export const hasFullCareScope = (dataMyProfile: any): boolean =>
  !!(dataMyProfile?.loggedUserRoles || dataMyProfile?.roles)?.includes(
    CONSTANTS.ROLE_DYNAMIC_ROUTE_CARE_FULL_SCOPE
  )

/** Version hook, pour les composants qui ont déjà accès au contexte profil. */
export const useHasFullCareScope = (): boolean => {
  const { dataMyProfile } = useContext(MyProfileContext)
  return hasFullCareScope(dataMyProfile)
}
